export default "__VITE_ASSET__DIbRFV9r__"